import React, { useState } from "react";
import { toast } from "react-toastify";
import { PostRoute } from "Components/Custom_hooks/Routes";

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      name === "" ||
      contactNumber === "" ||
      email === "" ||
      message === "" ||
      subject === ""
    ) {
      return toast.error("Error!! Please fillout the complete form.");
    }

    const bodyData = {
      name,
      email,
      message,
      contactNumber,
      subject,
    };

    PostRoute(
      "sendEmail",
      () => {
        setSending(true);
      },
      (res) => {
        setSending(false);
        setName("");
        setEmail("");
        setContactNumber("");
        setMessage("");
        setSubject("");

        toast.success(
          "Data submitted successfully. Our official will contact you soon....",
        );
      },
      bodyData,
    );
  };

  return (
    <section id="contact" className="contact-section contact-style-3">
      <div className="container">
        {/* TITLE */}
        <div className="row justify-content-center">
          <div className="col-xxl-5 col-xl-5 col-lg-7 col-md-10">
            <div className="section-title text-center mb-50">
              <h3 className="mb-15 wow fadeInUp" data-wow-delay=".2s">
                Get in touch
              </h3>

              <p className="wow fadeInUp" data-wow-delay=".4s">
                Built for students who aim higher — and are willing to prepare
                smarter.!
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          {/* LEFT FORM */}
          <div className="col-lg-8">
            <div
              className="contact-form-wrapper wow fadeInUp"
              data-wow-delay=".2s"
            >
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* NAME */}
                  <div className="col-md-6">
                    <div className="single-input">
                      <input
                        type="text"
                        name="name"
                        className="form-input"
                        placeholder="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      <i className="lni lni-user"></i>
                    </div>
                  </div>

                  {/* EMAIL */}
                  <div className="col-md-6">
                    <div className="single-input">
                      <input
                        type="email"
                        name="email"
                        className="form-input"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <i className="lni lni-envelope"></i>
                    </div>
                  </div>

                  {/* CONTACT NUMBER */}
                  <div className="col-md-6">
                    <div className="single-input">
                      <input
                        type="text"
                        name="number"
                        className="form-input"
                        placeholder="Number"
                        value={contactNumber}
                        onChange={(e) => setContactNumber(e.target.value)}
                      />
                      <i className="lni lni-phone"></i>
                    </div>
                  </div>

                  {/* SUBJECT */}
                  <div className="col-md-6">
                    <div className="single-input">
                      <input
                        type="text"
                        name="subject"
                        className="form-input"
                        placeholder="Subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                      />
                      <i className="lni lni-text-format"></i>
                    </div>
                  </div>

                  {/* MESSAGE */}
                  <div className="col-md-12">
                    <div className="single-input">
                      <textarea
                        name="message"
                        className="form-input"
                        placeholder="Message"
                        rows="6"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      ></textarea>

                      <i className="lni lni-comments-alt"></i>
                    </div>
                  </div>

                  {/* BUTTON */}
                  <div className="col-md-12">
                    <div className="form-button">
                      <button
                        style={{ backgroundColor: "#3b52ff" }}
                        type="submit"
                        className="button"
                        disabled={sending}
                      >
                        <i className="lni lni-telegram-original"></i>{" "}
                        {sending ? "Sending..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* RIGHT INFO */}
          <div className="col-lg-4">
            <div className="left-wrapper">
              <div className="row">
                {/* PHONE */}
                <div className="col-lg-12 col-md-6">
                  <div
                    className="single-item wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <div
                      className="icon"
                      style={{ backgroundColor: "#3b52ff" }}
                    >
                      <i className="lni lni-phone"></i>
                    </div>

                    <div className="text">
                      <p>+447741032801</p>
                    </div>
                  </div>
                </div>

                {/* EMAIL */}
                <div className="col-lg-12 col-md-6">
                  <div
                    className="single-item wow fadeInUp"
                    data-wow-delay=".4s"
                  >
                    <div
                      className="icon"
                      style={{ backgroundColor: "#3b52ff" }}
                    >
                      <i className="lni lni-envelope"></i>
                    </div>

                    <div className="text">
                      <p>info@eduskillprep.com</p>
                    </div>
                  </div>
                </div>

                {/* ADDRESS */}
                <div className="col-lg-12 col-md-6">
                  <div
                    className="single-item wow fadeInUp"
                    data-wow-delay=".5s"
                  >
                    <div
                      className="icon"
                      style={{ backgroundColor: "#3b52ff" }}
                    >
                      <i className="lni lni-map-marker"></i>
                    </div>

                    <div className="text">
                      <p>45 Webb Road Tipton DY40LQ United Kingdom</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* RIGHT INFO END */}
        </div>
      </div>
    </section>
  );
}

export default Contact;
